"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObjSource = isObjSource;
exports.makeObjSurface = makeObjSurface;

var THREE = _interopRequireWildcard(require("three"));

var _OBJLoader = require("three/examples/jsm/loaders/OBJLoader");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function isObjSource(src) {
  if (typeof src === 'string') {
    if (src.endsWith('.obj')) {
      return true;
    }
  } else if ('name' in src) {
    if (src.name.endsWith('.obj')) {
      return true;
    }
  }

  return false;
}

function makeObjSurface(text, colorStr) {
  var loader = new _OBJLoader.OBJLoader();
  var group = loader.parse(text);

  for (var i = 0; i < group.children.length; i += 1) {
    if (group.children[i] instanceof THREE.Mesh) {
      var mesh = group.children[i];
      var material = new THREE.MeshLambertMaterial();

      if (colorStr) {
        material.color.set(colorStr);
      }

      mesh.material = material;
      return mesh;
    }
  }

  return null;
}